module.exports = __webpack_public_path__ + "templates.collapse-section-17308312.html";